<template>
  <div class="floatTip">
    <!-- 悬浮区域 -->
    <div class="floatLeft" :style="{ top: showTop + 'px' }">
      <div
        class=""
        v-for="(item, index) in imgList"
        :key="index"
        v-show="floatShow === index"
      >
        <div class="float_body">
          <img :src="item.picture" alt="" srcset="" />
        </div>
      </div>
    </div>
    <div class="floatTop" @mouseleave="floatShow = ''">
      <div
        class="floatTop fixedBox_view"
        style="box-shadow: none"
        @mouseenter="setFloatShow(0)"
      >
        <img src="@/assets/img/float/dyh.png" style="height: 20px" alt="" />
        <p>公众号</p>
      </div>
      <div
        class="floatTop fixedBox_view"
        style="box-shadow: none"
        @mouseenter="setFloatShow(1)"
      >
        <img
          src="@/assets/img/float/service.png"
          style="width: 20px; height: 20px"
          alt=""
        />
        <p>企业微信</p>
      </div>
    </div>

    <!-- 返回顶部 -->

    <div
      class="floatBootm fixedBox_view"
      @mouseenter="setFloatShow(2)"
      @mouseleave="floatShow = ''"
    >
      <img
        src="@/assets/img/float/backtop.png"
        style="width: 18px; height: 17px"
        alt=""
      />
      <p>电话咨询</p>
    </div>
  </div>
</template>

<script>
import { getBasicInfo, getNavList } from "@/api/moudles/user.js";
export default {
  data() {
    return {
      basicInfo: {},
      imgList: [],
      showTop: 0,
      floatShow: -1,
    };
  },
  mounted() {
    this.getNavList();
  },
  methods: {
    setFloatShow(index) {
      const setTop = document.querySelectorAll(".fixedBox_view")[index];
      this.showTop = setTop.offsetTop;
      this.floatShow = index;
    },
    // 导航栏
    async getNavList() {
      await getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          const indexCodeList = res.data[0].children;
          indexCodeList.forEach((item) => {
            if (item.label == "基本信息") {
              this.getBasicInfo(item.key);
            }
          });
        },
      });
    },
    // 获取基本信息
    async getBasicInfo(column_code) {
      await getBasicInfo({
        data: {
          column_code,
        },
        success: (res) => {
          // console.log("基本信息", res);
          this.basicInfo = res.data;
          this.imgList = [
            {
              picture: res.data.qrCode,
            },
            {
              picture: res.data.enterpriseWX,
            },
            {
              picture: res.data.enterpriseWXOutside,
            },
          ];
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .floatTip {
    display: none;
  }
}
@media screen and (min-width: 750px) {
  .floatTip {
    position: fixed;
    right: 38px;
    top: 50vh;
    z-index: 999;
  }
}
/* 悬浮窗 */
.floatLeft {
  position: absolute;
  z-index: 21;
  right: 80px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 50%);
  border-radius: 6px;
  overflow: hidden;
}
.float_body {
  padding: 10px;
  width: max-content;
  /* max-width: 200px; */
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.float_body img {
  min-width: 120px;
  height: 100%;
}

.fixedBox_view {
  cursor: pointer;
}

.floatTop {
  width: 56px;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(184, 184, 184, 0.5);
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.floatBootm {
  margin-top: 14px;
  width: 56px;
  height: 58px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(184, 184, 184, 0.5);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}

.floatTop img,
.floatBootm img {
  cursor: pointer;
}

.floatTop p,
.floatBootm p {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #125db2;
  line-height: 14px;
  cursor: pointer;
}
</style>
